import EventEmitter from 'events';
import React, { createContext, PropsWithChildren, useEffect, useMemo } from 'react';
import { useDelayed } from '../../hooks/useDelayed';

export type RefreshableBlock =
  | 'personinteraction'
  | 'favoritedusers'
  | 'favoritedpages'
  | 'watchedpagemessagesblock'
  | 'pagemetainfo'
  | 'additionalprivilegeconfig'
  | 'basicprivilegeconfig';

type RefreshBlockContext = {
  refresh: (refreshProps?: any) => void;
  delayedRefresh: (refreshProps?: any) => void;
  refreshCount: number;
  refreshProps?: any;
  uuid: string;
};
type RefreshBlockContextProps = Omit<RefreshBlockContext, 'delayedRefresh'> & { resourceTypes?: RefreshableBlock[] };
export const RefreshBlockContext = createContext<RefreshBlockContext | undefined>(undefined);
export const refreshEvents: EventEmitter = new EventEmitter();

export function RefreshBlockContextProvider({
  refresh,
  refreshCount,
  refreshProps,
  uuid,
  resourceTypes,
  children,
}: PropsWithChildren<RefreshBlockContextProps>) {
  const delayedRefresh = useDelayed(refresh);

  const refreshContextValue = useMemo(
    () => ({
      refresh,
      delayedRefresh,
      refreshCount,
      refreshProps,
      uuid,
    }),
    [refresh, delayedRefresh, refreshCount, refreshProps, uuid],
  );

  useEffect(() => {
    resourceTypes?.forEach((key) => {
      refreshEvents.on(key, () => {
        refresh();
      });
    });

    return () => {
      resourceTypes?.forEach((key) => {
        refreshEvents.removeAllListeners(key);
      });
    };
  }, [refresh, resourceTypes, uuid]);

  return <RefreshBlockContext.Provider value={refreshContextValue}>{children}</RefreshBlockContext.Provider>;
}
